import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { CandidateProfile } from '../../../Redux/action/CandidateProfileAction';
import TableHeader from '../../Common/TableHeader';

import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


const CustomArrow = ({ className, style, onClick }) => (
    <div
      className={className}
      style={{ ...style, backgroundColor:'' }} // Replace 'your_arrow_color' with the desired color
      onClick={onClick}
    />
  );

const ListProjects = () => {
    const { userResult } = useSelector((state) => state.Auth);
    const id = userResult?.userid;;

    const dispatch = useDispatch();

    const location = useLocation();

    useEffect(() => {
        if (location.state === null) {
            dispatch(CandidateProfile(id));
        } else {
            dispatch(CandidateProfile(location.state.id));
        }
    }, []);

    const projects = useSelector((state) => state?.Profile?.result?.candidateProjects);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: <CustomArrow className="slick-prev" />,
    nextArrow: <CustomArrow className="slick-next" />,
    };

    return (
        <div>
            <TableHeader heading={'My Projects'} />
            <div className="projects-container">
                {projects?.map((project, index) => (
                    <div className="project-card" key={index}>
                        <h2 className="project-title">{project.projectName}</h2>
                        <p className="project-info"><span className='pj_bold'>Client:</span> {project.client || 'N/A'}</p>
                        <p className="project-info"><span className='pj_bold'>Client Location:</span> {project.clientLocation || 'N/A'}</p>
                        <p className="project-info"><span className='pj_bold'>Start Date:</span> {project.startDate || 'N/A'}</p>
                        <p className="project-info"><span className='pj_bold'>End Date:</span> {project.endDate || 'N/A'}</p>
                        <p className="project-info"><span className='pj_bold'>Role:</span> {project.role || 'N/A'}</p>
                        <p className="project-info"><span className='pj_bold'>Technologies:</span> {project.technologies.join(', ')}</p>
                        <p className="project-info"><span className='pj_bold'>Description:</span> {project.description || 'N/A'}</p>
                        <p className="project-info"><span className='pj_bold'>Duration:</span> {project.duration || 'N/A'}</p>
                        <p className="project-info"><span className='pj_bold'>Project Industry:</span> {project.projectIndustry || 'N/A'}</p>
                        <p className="project-info"><span className='pj_bold'>Team Size:</span> {project.teamSize || 'N/A'}</p>
                        <p className="project-info"><span className='pj_bold'>Project URL:</span> {project.projectUrl || 'N/A'}</p>
                        {project.projectImages && project.projectImages.length > 0 && (
                            <Slider {...settings}>
                                {project.projectImages.map((image, imgIndex) => (
                                    <div key={imgIndex}>
                                        <img src={image} alt={`Project Image ${imgIndex}`} className="project-image" />
                                    </div>
                                ))}
                            </Slider>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ListProjects;
